import Axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

export const axios = Axios.create();

export const authClient = {
  getApplications($config?: AxiosRequestConfig): AxiosPromise<ApplicationDto[]> {
    const url = '/auth/api/authorisation/applications';

    return axios.request<ApplicationDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};

export interface ApplicationDto {
  id: number;
  userId: number;
  shortCode: string;
  name: string;
  isAccessibleOutsideAD: boolean;
  applicationUrl: string;
}
